import React, { useEffect, useState } from 'react'
import { keyframes } from '@emotion/react'
import {
  Box,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Progress,
  Text,
  VStack
} from '@chakra-ui/react'

interface SendingOverlayProps {
  isOpen: boolean
  title?: string
  messages?: string[]
}

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
`

const MESSAGE_INTERVAL_MS = 2500

const defaultMessages = [
  'Gardando a túa inscrición...',
  'Preparando o correo de confirmación...',
  'Xa case está!'
]

const SendingOverlay: React.FC<SendingOverlayProps> = ({
  isOpen,
  title = 'Enviando a túa inscrición',
  messages = defaultMessages
}) => {
  const [messageIndex, setMessageIndex] = useState(0)

  useEffect(() => {
    if (!isOpen) {
      setMessageIndex(0)
      return
    }
    // Paramos na última mensaxe en vez de dar a volta, para non parecer que se reinicia
    const interval = setInterval(() => {
      setMessageIndex(index => Math.min(index + 1, messages.length - 1))
    }, MESSAGE_INTERVAL_MS)
    return () => { clearInterval(interval) }
  }, [isOpen, messages.length])

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
      motionPreset="scale"
    >
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(6px)"/>
      <ModalContent mx={6} borderRadius="2xl" overflow="hidden" role="status" aria-live="polite">
        <ModalBody py={10} px={8}>
          <VStack spacing={6} textAlign="center">
            <Box position="relative" w="120px" h="120px">
              <Box
                position="absolute"
                inset={0}
                borderRadius="full"
                border="4px solid"
                borderColor="cyan.100"
                borderTopColor="cyan.400"
                animation={`${spin} 1.1s linear infinite`}
              />
              <Image
                src="/favicon/android-chrome-192x192.png"
                alt=""
                position="absolute"
                inset="18px"
                w="84px"
                h="84px"
                objectFit="contain"
                animation={`${pulse} 1.8s ease-in-out infinite`}
              />
            </Box>
            <VStack spacing={1}>
              <Text fontSize="xl" fontWeight="bold" color="gray.700">{title}</Text>
              <Text fontSize="md" color="cyan.600" minH="24px" key={messageIndex}>
                {messages[messageIndex]}
              </Text>
            </VStack>
            <Progress isIndeterminate colorScheme="cyan" size="xs" w="100%" borderRadius="full"/>
            <Text fontSize="xs" color="gray.500">
              Non peches nin recargues a páxina ata que remate.
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default SendingOverlay
